export default "__VITE_ASSET__Bj8y7aQ2__"